export default '/build/bf645742.png'